import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material";

@Component({
  selector: 'my-modal-confirmation',
  styles: [],
  templateUrl: './modal-confirmation.component.html'
})

export class modalConfirmationComponent implements OnInit {

    // ----------------------------------- DECLARACIÓN DE VARIABLES -----------------------------------
    public mensaje: string;
    public accion: number;    

    // ----------------------------------- DECLARACIÓN DE FUNCIONES -----------------------------------
    constructor(private dialogRef: MatDialogRef<modalConfirmationComponent>, @Inject(MAT_DIALOG_DATA) data) {
        this.mensaje = data.mensaje;
    }

    ngOnInit() {

    }

    aceptar(){
        this.accion = 1;
        this.dialogRef.close(this.accion);
    }

    cerrarModal(){
        this.accion = 0;
        this.dialogRef.close(this.accion);
    }

}



// WEBPACK FOOTER //
// ./src/app/utils/modal/modal-confirmation.component.ts